import {Injectable} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LoginService {
  // Read (and cleared) by LoginComponent once Auth0's own post-logout redirect lands back in the
  // app - see logoutWithReturnUrl for why we don't route to /login ourselves here.
  public static readonly POST_LOGOUT_RETURN_URL_KEY = 'postLogoutReturnUrl';

  constructor(private authService: AuthService,
              private httpClient: HttpClient) {
  }

  logout() {
    // Ending up back at /login happens on its own: auth0Service.logout() below is a real
    // full-page redirect to Auth0, which redirects back into the app once the SSO session is
    // actually cleared, at which point AdminGuard sends unauthenticated users to /login. We
    // deliberately do NOT also call router.navigate(['/login']) here - that used to race the
    // Auth0 redirect (both are full-page navigations fired back-to-back), and depending on which
    // one the browser honored, LoginComponent's loginWithRedirect() could fire before Auth0's
    // logout actually completed, leaving the SSO session cookie intact and dropping the user into
    // an MFA/OTP step-up prompt instead of a fresh login form on their next sign-in.
    this.authService.logout().subscribe();
  }

  public sendChangePasswordEmail(email: string): Observable<any> {
    return this.httpClient.post(`https://${environment.auth0.domain}/dbconnections/change_password`, {
      client_id: environment.auth0.clientId,
      email,
      connection: 'Username-Password-Authentication',
    }, {
      responseType: 'text',
    });
  }

  logoutWithReturnUrl(returnUrl) {
    // Stash it for LoginComponent to pick back up after the real Auth0 round-trip (see logout()
    // above for why we don't navigate to /login ourselves) - AdminGuard's own returnUrl would
    // otherwise just point back at whatever route triggered its guard after landing on the
    // post-logout page, not the page the user was actually force-logged-out of.
    sessionStorage.setItem(LoginService.POST_LOGOUT_RETURN_URL_KEY, returnUrl);
    this.authService.logout().subscribe();
  }
}
